/**
 * Keep common mixins in sync with the jade version in this directory.
 * This is a necessary evil while we are in the middle of tsx migration.
 * */
import {jsx} from 'panel';

import {CellRenderContext, TableRow} from './types';

export const FieldWithMatches = ({context}: {item?: TableRow; context: CellRenderContext}) => (
  <div>
    {context.matchParts ? (
      context.matchParts.map((part) => <span sel='.mp-table-cell-match-part'>{part}</span>)
    ) : (
      <div sel='.mp-table-cell-label'>{context.label}</div>
    )}
  </div>
);

export const getLinkCellRenderer = (attrTransform: (TableRow) => any = () => ({})) => (
  row: TableRow,
  context: CellRenderContext,
) => <a attrs={Object.assign({href: context.label}, attrTransform(row))}>{context.label}</a>;
